var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TokenInfoPopover',{attrs:{"symbol":_vm.symbol,"contract":_vm.contract,"disabled":_vm.disabled}},[_c('TokenImage',_vm._b({attrs:{"src":_vm.localSrc}},'TokenImage',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }